import React from "react";
import styled from "styled-components";

const services = [
  { title: "Monthly Contributions", desc: "Grow savings as a community." },
  { title: "Interest-Friendly Loans", desc: "Borrow from your group without banks." },
  { title: "Automated Tracking", desc: "Easily track payments & dividends." }
];

const ServicesSection = () => {
  return (
    <Section id="services">
      <h2>Our Services</h2>
      <CardGrid>
        {services.map((service, idx) => (
          <ServiceCard key={idx}>
            <h3>{service.title}</h3>
            <p>{service.desc}</p>
          </ServiceCard>
        ))}
      </CardGrid>
    </Section>
  );
};

const Section = styled.section`
  padding: 4rem 2rem;
  background: #ffffff;
  text-align: center;

  h2 {
    font-size: 1.75rem;
    margin-bottom: 2rem;
    color: #003366;
  }
`;

const CardGrid = styled.div`
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
`;

const ServiceCard = styled.div`
  padding: 1.5rem;
  background: #f8f9fa;
  border-radius: 12px;

  h3 {
    color: #007bff;
    margin-bottom: 1rem;
  }

  p {
    color: #333;
  }
`;

export default ServicesSection;
